import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ICustomer, IOperator, IOperatorForSettingsView } from 'app/models';
import { CustomerService, OperatorService } from 'app/services';
import { MessageService } from 'app/services/message/message.service';
import { AbstractSettingsFilteredTableComponent } from '../setting-mngt-filtered-table';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';
import { OperatorMngtDetailComponent } from '../operator-mngt-detail/operator-mngt-detail.component';

@Component({
  selector: 'app-operator-mngt',
  templateUrl: './operator-mngt.component.html',
  styleUrls: ['./operator-mngt.component.scss'],
})
export class OperatorMngtComponent extends AbstractSettingsFilteredTableComponent<IOperatorForSettingsView> implements OnInit {

  @ViewChild(OperatorMngtDetailComponent)
  private operatorMngtDetailComponent!: OperatorMngtDetailComponent;

  customers: ICustomer[] = [];

  readonly displayedColumns = ['code', 'name', 'customer', 'Actions'];

  dataSource = new MatTableDataSource<IOperatorForSettingsView>();

  constructor(
    private readonly operatorService: OperatorService,
    private readonly customerService: CustomerService,
    public readonly dialog: MatDialog,
    private readonly messageService: MessageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getCustomers();
    this.getOperators();
  }

  getOperators(): void {
    this.operatorService.findAll().subscribe(
      (operators) => {
        this.dataSource.data = operators.map((op) => {
          (op as IOperatorForSettingsView).customerName = this.getCustomerById(op.customerId)?.name;
          return op as IOperatorForSettingsView;
        });
      },
      () => this.messageService.showDirectSimpleMessage(` Loading operators error `)
    );
  }

  getCustomers(): void {
    this.customerService.findAllCustomers().subscribe(
      (customers) => (this.customers = customers.sort((a, b) => (a.name < b.name ? -1 : 1))),
      () => this.messageService.showDirectSimpleMessage(` Loading customers error `)
    );
  }

  getCustomerById(id: number): ICustomer | undefined {
    return this.customers.find((c) => c.id === id);
  }

  onOperatorSaved(saved: boolean): void {
    const msg = saved ? ` Operator correctly saved ` : ` Operator NOT correctly saved `;
    this.messageService.showDirectSimpleMessage(msg);
    this.getOperators();
  }

  edit(operator: IOperator): void {
    this.operatorMngtDetailComponent.initEdit(operator);
  }

  deleteConfirmDialog(operator: IOperator): void {
    const message = `Are you sure you want to delete operator "${operator.name}" (${operator.code})?`;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: new ConfirmDialogModel('Confirm Delete', message),
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed && operator.id) {
        this.operatorService.delete(operator.id).subscribe(
          () => this.messageService.showDirectSimpleMessage(` Operator deleted `),
          () => this.messageService.showDirectSimpleMessage(` Operator delete error `),
          () => this.getOperators()
        );
      }
    });
  }
}
